import { render } from "./Cases.vue?vue&type=template&id=5710d617&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"

import "./Cases.vue?vue&type=style&index=0&id=5710d617&scoped=true&lang=css"
import "./Cases.vue?vue&type=style&index=1&id=5710d617&lang=css"
script.render = render
script.__scopeId = "data-v-5710d617"

export default script